import Img, { FluidObject } from "gatsby-image";
import React, { CSSProperties, ReactNode } from "react";
import { Trans } from "react-i18next";
import "./layout.css";

const FeatureContainerFour = ({
  excerpt,
  style,
  headerIconSource
}: {
  headerIcon?: string;
  excerpt?: string;
  style?: CSSProperties;
  headerIconSource: HTMLImageElement["src"];
}) => {
  return (
    <div className="feature-container-four">
      <img
        className="feature-container-image"
        style={style}
        alt="Feature Icon"
        src={headerIconSource}
      />
      <p>
        <Trans i18nKey={excerpt} />
      </p>
    </div>
  );
};

export default FeatureContainerFour;
